export default "__VITE_ASSET__CqEggDtd__"